import { Component } from '@angular/core';
import { DialogCloseReason, DialogBase } from '../base-dialog';

export interface IConfirmData {
  header: string;
  message: string;
  okCaption?: string;
  cancelCaption?: string;
}

@Component({
  selector: 'confirm-dialog',
  templateUrl: 'confirm.html'
})
export class ConfirmDialogComponent extends DialogBase {
  okCaption: string;
  cancelCaption: string;

  constructor() {
    super();
  }

  initDialog() {
    this.okCaption = this.extraData.okCaption ? this.extraData.okCaption : 'OK';
    this.cancelCaption = this.extraData.cancelCaption ? this.extraData.cancelCaption : 'Cancel';
  }

  getTypeClass(): string {
    return 'confirm';
  }

  ok() {
    this.close({ reason: DialogCloseReason.OK });
  }

  cancel() {
    this.close({ reason: DialogCloseReason.CANCEL });
  }

}

